import { SUPPLIER_BACKEND_API_ENDPOINTS } from "../config/apiConfig";
import { apiClient } from "./api-client.service";

import type { AdminSupplierDocumentPayload } from "../types/admin-supplier-document.types";

type AdminSupplierDocumentResponse = {
  success: boolean;
  statusCode: number;
  message: string;
  resData: unknown;
};

const endpoints = SUPPLIER_BACKEND_API_ENDPOINTS.adminSupplierDocument;

export const adminSupplierDocumentService = {
  async verifyDocument(
    documentId: number | string,
    payload: AdminSupplierDocumentPayload,
  ): Promise<AdminSupplierDocumentResponse> {
    try {
      return await apiClient<AdminSupplierDocumentResponse>(
        endpoints.verifyDocument(documentId),
        {
          method: "PATCH",
          body: JSON.stringify(payload),
          isAuthenticated: true,
        },
      );
    } catch (error) {
      return {
        success: false,
        statusCode: 500,
        message:
          error instanceof Error
            ? error.message
            : "Failed to update document due to an unexpected error.",
        resData: null,
      };
    }
  },
};
